import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { grid, aboutImg, aboutText } from "./about.module.scss"

const getData = graphql`
  {
    strapiAboutPage {
      about
      media {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const AboutLong = () => {
  const {
    strapiAboutPage: { about, media },
  } = useStaticQuery(getData)
  return (
    <section>
      <article className={grid}>
        <Img fluid={media.childImageSharp.fluid} className={aboutImg} />
        <div className={aboutText}>
          <h2>About</h2>
          <p>{about}</p>
        </div>
      </article>
    </section>
  )
}

export default AboutLong
